import Vue from 'vue'

import App from './App.vue'
import router from './router'
import Vant from 'vant'
import VueGecWxJssdk from '@/plugins/weixin/index'
import 'vant/lib/index.css'
import './assets/fonts.css'

Vue.use(VueGecWxJssdk)
Vue.use(Vant)
new Vue({ router, render: function (h) { return h(App) } }).$mount('#app')
